import {changeStatus, getStatus, list, protectAll, unprotectAll, refresh, backupAll, exportSnapshot} from "@/services/api/app/seat-management/team";
import {defaultPagination} from "@/services/pagination";

const defaultState = () => ({
  teams: [],
  teamsMap: {},
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null,
  filter: {
    statuses: null,
  },
  status: null
});

export default {
  namespaced: true,

  actions: {
    list({commit, state},) {
      return list({
        pagination: state.pagination,
        filter: state.filter,
        search: state.search
      })
        .then(({result, pagination, search, statuses}) => {
          commit('setTeams', result)
          commit('setPagination', pagination)
        })
    },
    getStatus({commit}) {
      return getStatus()
        .then(result => {
          commit('setStatus', result)
        })
    },
    changeStatus({commit}, data) {
      return changeStatus(data)
    },
    refresh({commit}) {
      return refresh()
    },
    backupAll({commit}) {
      return backupAll()
    },
    protectAll() {
      return protectAll();
    },
    unprotectAll() {
      return unprotectAll();
    },
    exportSnapshot({commit, state}, {filter, search, pagination}) {
      return exportSnapshot(filter, search, pagination);
    },
  },

  mutations: {
    setTeams(state, teams) {
      state.teams = teams;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'name',
        sortDescending: false
      };
    },
    setSearch(state, search) {
      state.search = search;
    },
    setFilter(state, filter) {
      state.filter = filter;
    },
    setStatus(state, status) {
      state.status = status
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },


  state: defaultState()
}
